import type { TFunction } from "i18next";
import type { GridColDef } from "src/components/DataGrid/DataGrid.tsx";
import { formatDateTime, formatPrice } from "@exonn/utils";
import { Currency } from "src/common/constants.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import type { B2bGateOrderRow } from "src/admin/lists/b2b-gate-order/list.types.ts";
import { getResourceFieldTranslation } from "src/system/getResourceFieldOptions.ts";

export const getColumns = ({
  t,
}: {
  t: TFunction;
}): GridColDef<B2bGateOrderRow>[] => [
  {
    field: "id",
    type: "string" as const,
    width: 200,
    headerName: t("table.columns.id"),
  },

  {
    field: "status",
    type: "singleSelect" as const,
    width: 150,
    sortable: false,
    headerFilterSelectProps: {
      options: {
        resource: ResourceEnum.B2bGateOrder,
        field: "status",
      },
    },
    valueGetter: (value: string, row) =>
      row.is_child
        ? getResourceFieldTranslation({
            resource: ResourceEnum.B2bGateOrder,
            field: "status",
            type: "option_label",
            value: value,
            t,
          })
        : "",
    headerName: t("table.columns.status"),
  },
  {
    field: "shipping_service_provider",
    type: "string" as const,
    width: 200,
    headerName: t("table.columns.shipping_service_provider"),
  },
  {
    field: "tracking_number",
    type: "string" as const,
    width: 200,
    headerName: t("table.columns.tracking_number"),
  },
  {
    field: "supplier",
    type: "multiSelect" as const,
    backendFilterName: "supplier_id",
    width: 150,
    sortable: false,
    valueGetter: (value, row) => (row.descendants_count ? "" : value),
    headerFilterSelectProps: {
      serverOptions: {
        resource: ResourceEnum.B2bGateSupplier,
        labelProp: "company",
      },
    },
    headerName: t("table.columns.supplier"),
  },
  {
    field: "created_at",
    type: "dateRange" as const,
    valueFormatter: (value: string) => value && formatDateTime(value),
    width: 150,
    headerName: t("table.columns.orderDate"),
  },

  {
    field: "total_price",
    type: "number" as const,
    width: 150,
    align: "right",
    valueGetter: (value) => formatPrice(+value, Currency.EUR),
    headerName: t("table.columns.total"),
  },
  {
    field: "total_gross_price",
    type: "number" as const,
    width: 150,
    align: "right",
    valueGetter: (value) => formatPrice(+value, Currency.EUR),
    headerName: t("table.columns.total_gross"),
  },
];
